<template>
    <div>
      <clientNav />
      <main>
        <router-view />
      </main>
      <!-- <Footer /> -->
    </div>  
  </template>
  
  <script>
  import clientNav from "../../components/nav/clientHeader.vue";
  
  export default {
    components: {
    clientNav,
     
    },
    setup() {},
  };
  </script>
  
  <style lang='less'>
  </style>
  